import React from 'react'
import PropTypes from 'prop-types'
import WelcomeComponent from '../components/dashboard/welcome_component'
import EventsComponent from '../components/dashboard/events_component'
import BottomComponent from '../components/dashboard/bottom_component'
import HelpComponent from '../components/dashboard/help_component'
import DiscoverComponent from '../components/dashboard/discover_component'
import { useSelector } from 'react-redux'

const GgGolfHubDashboardComponent = () => {
  const userFirstName = useSelector(state => state.misc.userFirstName)
  const helpItems = useSelector(state => state.misc.helpItems)
  const discoverUrl = useSelector(state => state.misc.discoverUrl)

  const numberOfLeagues = useSelector(state => state.events.numberOfLeagues)

  return (
    <div className='container-fluid dashboard-component'>
      <div className='row'>
        <div className='col'>
          {numberOfLeagues === 0 && <WelcomeComponent title={window.I18n.t('gg_golf_hub.dashboard.welcome_title', { first_name: userFirstName })} subtile={window.I18n.t('gg_golf_hub.dashboard.welcome_subtitle')} />}
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <EventsComponent />
        </div>
      </div>
      <div className='row add-margin-top-20 bottom-row'>
        <div className='col-lg-4 no-padding-left'>
          <BottomComponent title={window.I18n.t('gg_golf_hub.dashboard.help')}>
            <HelpComponent helpItems={helpItems} />
          </BottomComponent>
        </div>
        <div className='col-lg-8 no-padding-right'>
          <BottomComponent title={window.I18n.t('gg_golf_hub.dashboard.discover')}>
            <DiscoverComponent discoverUrl={discoverUrl} />
          </BottomComponent>
        </div>
      </div>
    </div>
  )
}

GgGolfHubDashboardComponent.propTypes = {
  helpItems: PropTypes.array,
  userFirstName: PropTypes.string,
  getLeaguesPath: PropTypes.string,
  getLeagues: PropTypes.func,
  leagues: PropTypes.array,
}

export default GgGolfHubDashboardComponent
